import { render, staticRenderFns } from "./TakeQuestions.vue?vue&type=template&id=4269987a&scoped=true&"
import script from "./TakeQuestions.vue?vue&type=script&lang=js&"
export * from "./TakeQuestions.vue?vue&type=script&lang=js&"
import style0 from "./TakeQuestions.vue?vue&type=style&index=0&id=4269987a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4269987a",
  null
  
)

export default component.exports